// Module
var code = "<redux-decorator redux-provider=\"$.redux\" gettext-catalog=\"$.gettextCatalog\" render=\"$.params.component\" pass-through=\"$.params.props\"></redux-decorator>\n";
// Exports
export default code;